import React from 'react'
import { NavLink } from 'react-router-dom'
import './style.scss'

const Matches = () => {
    return (
        <div className="custom-navbar">
        <div className="container">
            <div className="row">
                <div className="col-12 text-center">
                    <NavLink
                        to="/matches/"
                        className={({ isActive }) => isActive ? "btn shadow-sm isActive" : "btn shadow-sm"}
                    >new matches</NavLink>
                    <NavLink
                        to="/matches/today"
                        className={({ isActive }) => isActive ? "btn shadow-sm isActive" : "btn shadow-sm"}
                    >today matches</NavLink>
                    <NavLink
                        to="/matches/all"
                        className={({ isActive }) => isActive ? "btn shadow-sm isActive" : "btn shadow-sm"}
                    >all matches</NavLink>
                    <NavLink
                        to="/matches/near-me"
                        className={({ isActive }) => isActive ? "btn shadow-sm isActive" : "btn shadow-sm"}
                    >near me</NavLink>
                    <NavLink
                        to="/matches/recently-viewed"
                        className={({ isActive }) => isActive ? "btn shadow-sm isActive" : "btn shadow-sm"}
                    >recently viewed</NavLink>
                </div>
            </div>
        </div>
    </div>
    );
};

export default Matches;